export default "__VITE_ASSET__oLTaHe_O__"